
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-viewer/post-comments",
      function () {
        return require("private-next-pages/instagram-viewer/post-comments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-viewer/post-comments"])
      });
    }
  